import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';
import { Input } from '../../ui/input';
export const NumberInput = forwardRef(({ ...props }, ref) => {
    return _jsx(NumericFormat, { customInput: Input, getInputRef: ref, ...props });
});
